<template>
  <vx-tooltip :text="`Status = ${statusSelected.text}`">
    <div
      class="flex px-3 py-2 rounded border  border-solid items-center"
      :class="`border-${statusSelected.color} text-${statusSelected.color}`"
    >
      <vs-icon
        class="pr-3"
        icon-pack="feather"
        :icon="statusSelected.icon"
      ></vs-icon>
      <div class="">
        {{ statusSelected.text }}
      </div>
      <!-- <vs-button :color="statusSelected.color" type="border" disable="true">{{
      statusSelected.text
    }}</vs-button> -->
    </div>
  </vx-tooltip>
</template>

<script>
import {
  STATUS_ACCEPT,
  STATUS_CONCEPT,
  STATUS_ARCHIVE,
  STATUS_DRAFT,
  STATUS_PROCCESS,
  STATUS_TRASH,
  STATUS_SEND
} from "@/const/surat";

export default {
  props: {
    status: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      statusList: [
        {
          status: STATUS_ACCEPT,
          color: "success",
          text: "Acc Kadis",
          icon: "icon-check-circle"
        },
        {
          status: STATUS_CONCEPT,
          color: "grey",
          text: "Konsep",
          icon: "icon-file"
        },
        {
          status: STATUS_ARCHIVE,
          color: "primary",
          text: "Arsip",
          icon: "icon-archive"
        },
        {
          status: STATUS_DRAFT,
          color: "warning",
          text: "Draf",
          icon: "icon-file-text"
        },
        {
          status: STATUS_PROCCESS,
          color: "warning",
          text: "Proses",
          icon: "icon-file-text"
        },
        {
          status: STATUS_TRASH,
          color: "danger",
          text: "Sampah",
          icon: "icon-trash"
        },
        {
          status: STATUS_SEND,
          color: "primary",
          text: "Terkirim",
          icon: "icon-send"
        }
      ]
    };
  },
  computed: {
    statusSelected() {
      return this.statusList.find(({ status }) => {
        return status == this.status;
      });
    }
  }
};
</script>
